import React from 'react';
import Pagination from 'react-bootstrap/Pagination';
import './paginate.scss';

const Paginate = ({ totalPages, currentPage, onPageChange }) => {
  const handlePageChange = (page) => {
    onPageChange(page);
  };

  const renderPaginationItems = () => {
    const items = [];
    const pageRange = 2; // Number of pages to display before and after the current page
    const ellipsis = <Pagination.Ellipsis key="ellipsis" />;
  
    if (totalPages > 1) {
      // Display first page
      items.push(
        <Pagination.Item key={1} active={currentPage === 1} onClick={() => handlePageChange(1)}>
          {1}
        </Pagination.Item>
      );
  
      // Display ellipsis if necessary before the current page
      if (currentPage > pageRange + 2) {
        items.push(ellipsis);
      }
  
      // Display pages around the current page
      for (let i = Math.max(2, currentPage - pageRange); i <= Math.min(totalPages - 1, currentPage + pageRange); i++) {
        items.push(
          <Pagination.Item key={i} active={currentPage === i} onClick={() => handlePageChange(i)}>
            {i}
          </Pagination.Item>
        );
      }
  
      // Display ellipsis if necessary after the current page
      if (currentPage < totalPages - pageRange - 1) {
        items.push(ellipsis);
      }
    }
  
    // Display last page
    items.push(
      <Pagination.Item key={totalPages} active={currentPage === totalPages} onClick={() => handlePageChange(totalPages)}>
        {totalPages}
      </Pagination.Item>
    );
  
    return items;
  };
  

  return (
    <>
    {/* <Pagination>
      <Pagination.First />
      <Pagination.Item>{1}</Pagination.Item>
      <Pagination.Item active>{2}</Pagination.Item>
      <Pagination.Item>{3}</Pagination.Item>
      <Pagination.Ellipsis />
      <Pagination.Item>{10}</Pagination.Item>
      <Pagination.Last />
    </Pagination> */}
    <Pagination>
      <Pagination.First onClick={() => handlePageChange(1)} />
        {renderPaginationItems()}
      <Pagination.Last onClick={() => handlePageChange(totalPages)} />
    </Pagination>
    </>
  );
};

export default Paginate;
